<template>
    <footer class="app-footer">
        <slot name="left"></slot>
		<div class="app-footer__social">
        	<a target="_blank" :href="facebook"><img src="/static/images/social-facebook-icon.png" alt="Facebook" /></a>
        </div>
        <slot name="right"></slot>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    props: ['facebook']
}
</script>




// WEBPACK FOOTER //
// src/shared/Footer.vue?74842840